import Raven from 'raven-js';
import { IGNORED_PURCHASE_ORDER_GENERATION_ERRORS } from 'self-service-api/constants/Errors';
import { getChirpError, getChirpInternalError } from '../../../utils/error';
export const logPurchaseOrderError = (error, additionalProperties) => {
  const chirpError = getChirpError(error);
  const chirpInternalError = getChirpInternalError(error);
  const errorType = (chirpError === null || chirpError === void 0 ? void 0 : chirpError.errorType) || (chirpInternalError === null || chirpInternalError === void 0 ? void 0 : chirpInternalError.type) || 'UNKNOWN';

  /**
   * Don't log no-op errors that shouldn't contribute to our error budget.
   */
  const isLowImpactError = errorType ? IGNORED_PURCHASE_ORDER_GENERATION_ERRORS[errorType] : true;

  /**
   * Only events with `level: 'error'` will be reported to LogFetch Errors
   * Events of all levels will be stored in the `ERRORS.SENTRY_V3` custom LogFetch event
   * https://product.hubteam.com/docs/observability/docs/errors/LogFetchErrors/raven-usage.html#raven-options
   */
  const level = isLowImpactError ? 'warning' : 'error';
  const extra = Object.assign({
    location: 'generatePurchaseOrder',
    errorType
  }, chirpError ? {
    chirpError
  } : {}, chirpInternalError ? {
    chirpInternalError
  } : {}, additionalProperties);
  Raven.captureException(new Error('Purchase order generation failed', {
    cause: error
  }), {
    level,
    extra
  });
};